'use strict';

import React from 'react/addons';

import OFS_I18N from 'ofs/i18n'

var gettext = OFS_I18N.gettext;
var interpolate = OFS_I18N.interpolate;

import Image from 'ofs/components/common/Image';
import ResponsiveImage from 'ofs/components/ResponsiveImage';


var messages = {
  PER_NIGHT: gettext('from %(price)s/night')
}


var HomeListItem = React.createClass({
  render() {
    var {url, image, price, title} = this.props;
    var priceLabel = interpolate(messages.PER_NIGHT, {price}, true);

    return (
      <li className="ofs-HomesList__Item">
        <a href={url}>
          <ResponsiveImage defaultWidth={240} {...image} />
        </a>
        <h5 className="ofs-HomesList__Title">
          <a href={url}>
            {title}
          </a>
        </h5>
        <span className="ofs-HomesList__Price"><span dangerouslySetInnerHTML={{__html: priceLabel}} /></span>
      </li>
    );
  }
});

export default HomeListItem;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/homeslist/HomesListItem.jsx
 **/